
const getObjectList = require('./getObjectList').default;
const fetchData = require('./fetchData').default;

export const REQUEST_FILTER_TRAT_LIST = 'tratList/REQUEST_FILTER_TRAT_LIST';
export const REQUEST_GET_TRAT_LIST = 'tratList/REQUEST_GET_TRAT_LIST';
export const RESPONSE_FILTER_TRAT_LIST = 'tratList/RESPONSE_FILTER_TRAT_LIST';
export const RESPONSE_GET_TRAT_LIST = 'tratList/RESPONSE_GET_TRAT_LIST';
export const SET_FILTER = 'tratList/SET_FILTER';

export const getTratList = () => {
    return (dispatch, getState) => {
        getObjectList({
            objectList: getState().tratList,
            requestFunc: requestGetTratList,
            responseFunc: responseGetTratList,
            url: '/api/trat/',
            dispatch
        });
    };
};

const getServerFilter = (filter) => {
    const odrudaZkratka = (filter['odruda'])
        ? filter['odruda'].odruda_zkratka
        : '';
    const obdobi = (filter['obdobi'])
        ? filter['obdobi'].rok_od
        : '';

    return `${odrudaZkratka}_${obdobi}`;
}

export const setFilter = (id, value) => {
    return (dispatch, getState) => {
        let oldFilter = getState().tratList.filter;
        let newFilter = {
            ...oldFilter
        };
        newFilter[id] = value;

        const oldServerFilter = getServerFilter(oldFilter);
        const newServerFilter = getServerFilter(newFilter);

        if (oldServerFilter !== newServerFilter) {
            dispatch(setFilterAttribute(id, value));
            let params = [];
            if (newFilter['odruda']) {
                params.push(['odruda', newFilter['odruda'].odruda_zkratka]);
            }
            if (newFilter['obdobi']) {
                params.push(['obdobi', newFilter['obdobi'].rok_od]);
            }
            let url = '/api/trat/filter?' + params.map(item => {
                return `${item[0]}=${item[1]}`;
            }).join('&');
            fetchData({
                requestFunc: requestFilterTratList,
                responseFunc: responseFilterTratList,
                url: url,
                dispatch
            });
        } else {
            return dispatch(setFilterAttribute(id, value));
        }
    }
}

const setFilterAttribute = (id, value) => ({
    type: SET_FILTER,
    attributeId: id,
    attributeValue: value
})

const requestFilterTratList = () => ({
    type: REQUEST_FILTER_TRAT_LIST
});

const requestGetTratList = () => ({
    type: REQUEST_GET_TRAT_LIST
});

const responseFilterTratList = (res) => ({
    type: RESPONSE_FILTER_TRAT_LIST,
    error: res.error,
    data: res.data
});

const responseGetTratList = (res) => ({
    type: RESPONSE_GET_TRAT_LIST,
    error: res.error,
    data: res.data
});
